import * as MutationsType from "./mutationsType";
import requestAxios from "@/helpers/request_axios";

export default {
  async getAllFilteredEvents({ commit }, { filters }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/event",
        method: "GET",
        params: filters,
      });

      commit(MutationsType.SET_EVENTS, response.data.data);

      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  // eslint-disable-next-line
  async saveEvent({}, { data }) {
    try {
      let response = await requestAxios({
        url: "/awy/api/v1/event",
        method: "POST",
        data: data,
      });
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async updateEvent({ commit }, { eventId, data }) {
    try {
      let response = await requestAxios({
        url: `/awy/api/v1/event/${eventId}`,
        method: "PATCH",
        data: data,
      });
      commit(MutationsType.UPDATE_EVENT, response.data.data);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  resetModuleEvent({ commit }) {
    commit(MutationsType.SET_EVENTS, null);
  },
};
